import type { WsConnectionEvent } from '@atlassian/graphql-subscription/utils/client';
import { fg } from '@atlassian/jira-feature-gating';
import { getAnalyticsWebClientPromise } from '@jira/platform__observability-product-analytics-web-client-async';
import { createConnectionEventReporter } from './createConnectionEventReporter.tsx';

/** Page-wide AGG socket lifecycle. Most closes are routine; filter on wasClean / closeCode. */
const fireWebSocketConnectionAnalytics = (event: WsConnectionEvent): void => {
	const { type, ...attributes } = event;

	getAnalyticsWebClientPromise().then((client) => {
		const analyticsClient = client.getInstance();
		if (!analyticsClient) {
			return;
		}

		analyticsClient.sendOperationalEvent({
			// GASv3 wants a verb; graphql-ws uses `error`.
			action: type === 'error' ? 'errored' : type,
			actionSubject: 'relaySubscriptionSocket',
			attributes,
			source: 'jiraRelayEnvironment',
		});
	});
};

/** `undefined` when gated off (no GasV3 socket events). */
export const getConnectionEventReporter = (): ((event: WsConnectionEvent) => void) | undefined => {
	if (!fg('crocs-972_ws_connection_telemetry')) {
		return undefined;
	}
	return fg('crocs-972_ws_connection_telemetry_volume')
		? createConnectionEventReporter()
		: fireWebSocketConnectionAnalytics;
};
